import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Tailwind-aware class joiner: later classes win, conditional values allowed. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
